var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`
  dashboard-workpackage
  ${_vm.color}
  ${_vm.text_color}--text
  ${_vm.color.includes('lighten') || _vm.color.includes('darken')? '':'lighten-1'}
  t-rounded
  t-shadow
  font-weight-light

  `,style:(`
${_vm.height?`height: ${_vm.height}px;`:''}
${_vm.width?`width: ${_vm.width}px;`: ''}
${_vm.margin?`margin: ${_vm.margin}px;`:''}
`)},[_c('div',{staticClass:"workbench-workpackage-header"},[_vm._t("header")],2),_c('div',{staticClass:"workbench-workpackage-content"},[_vm._t("content")],2),_c('v-spacer'),_c('div',{staticClass:"workbench-workpackage-footer"},[_vm._t("footer")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }